import { ChevronDown } from 'lucide-react'

export default function YearSelector({ years, selected, onChange }) {
  if (!years || years.length <= 1) return null

  return (
    <div className="relative">
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        className="appearance-none border border-[#77726e]/40 bg-[#f6f3ee] px-3 py-1.5 pr-8 text-sm text-[#2f3126] font-semibold focus:outline-none focus:ring-2 focus:ring-[#4e6498]/30 focus:border-[#4e6498] min-w-[140px]"
        title={`Date sélectionnée: ${selected}`}
      >
        {years.map((yearItem) => {
          const value = typeof yearItem === 'string' ? yearItem : yearItem.value
          const label = typeof yearItem === 'string' ? yearItem : yearItem.label
          return (
            <option key={value} value={value}>{label}</option>
          )
        })}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-[#77726e] pointer-events-none" />
    </div>
  )
}
